import request from '../utils/request'

/**
 * 会话管理API
 */

// 获取会话列表（分页）
export function getSessionListPaged(params) {
  return request({
    url: '/session/list',
    method: 'get',
    params: {
      page: params.page,
      page_size: params.page_size,
      project_id: params.project_id,
      status: params.status
    }
  })
}

// 获取当前用户的所有会话（通过项目关联，一次性获取）
export function getMySessionsPaged(params) {
  return request({
    url: '/session/my_sessions',
    method: 'get',
    params: {
      page: params.page,
      page_size: params.page_size,
      project_id: params.project_id,
      status: params.status
    }
  })
}

// 获取会话详情
export function getSessionDetail(id) {
  return request({
    url: `/session/${id}`,
    method: 'get'
  })
}

// 创建会话
export function createSession(data) {
  return request({
    url: '/session/create',
    method: 'post',
    data
  })
}

// 创建会话并加入队列
export function createSessionWithEnqueue(data) {
  return request({
    url: '/session/create_with_enqueue',
    method: 'post',
    data
  })
}

// 关闭会话
export function closeSession(id) {
  return request({
    url: `/session/${id}/close`,
    method: 'post'
  })
}

// 获取队列状态
export function getQueueStatus(receiverId) {
  return request({
    url: '/session/queue/status',
    method: 'get',
    params: {
      receiver_id: receiverId
    }
  })
}

// 取出下一个会话
export function dequeueNextSession(receiverId) {
  return request({
    url: '/session/queue/dequeue',
    method: 'post',
    data: {
      receiver_id: receiverId
    }
  })
}

// 获取待处理会话
export function fetchPendingSession(receiverId, lockExpireSeconds = 30, retryTimes = 1) {
  return request({
    url: '/session/fetch_pending',
    method: 'post',
    data: {
      receiver_id: receiverId,
      lock_expire_seconds: lockExpireSeconds,
      retry_times: retryTimes
    }
  })
}

// 获取待处理会话（带重试）
export function fetchPendingSessionWithRetry(receiverId, maxRetries = 3, lockExpireSeconds = 30) {
  return request({
    url: '/session/fetch_pending_with_retry',
    method: 'post',
    data: {
      receiver_id: receiverId,
      max_retries: maxRetries,
      lock_expire_seconds: lockExpireSeconds
    }
  })
}

// 增加会话消息计数
export function incrementMessageCount(id) {
  return request({
    url: `/session/${id}/increment_message_count`,
    method: 'post'
  })
}

// 获取根任务下的所有会话
export function getSessionsByRootTask(rootTaskId) {
  return request({
    url: `/session/root_task/${rootTaskId}`,
    method: 'get'
  })
}

// 获取父会话下的所有子会话
export function getChildSessions(parentSessionId) {
  return request({
    url: `/session/${parentSessionId}/children`,
    method: 'get'
  })
}

// 获取关联任务
export function getRelatedTasks(sessionId) {
  return request({
    url: `/session/${sessionId}/tasks`,
    method: 'get'
  })
}

// 删除会话
export function deleteSession(id) {
  return request({
    url: `/session/${id}`,
    method: 'delete'
  })
}

export default {
  getSessionListPaged,
  getSessionDetail,
  createSession,
  createSessionWithEnqueue,
  closeSession,
  getQueueStatus,
  dequeueNextSession,
  fetchPendingSession,
  fetchPendingSessionWithRetry,
  incrementMessageCount,
  getSessionsByRootTask,
  getChildSessions,
  getRelatedTasks,
  deleteSession
}
